module.exports = __webpack_public_path__ + "static/media/AppStore.86ae88d3.svg";